import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import toast from 'react-hot-toast';
import * as Apis from "../../../utils/helper/enum";
import * as CUSTOM from '../../../utils/helper/utils.js';
import globalRequest from '../../../utils/global/globalRequest';
import { changeLoader } from "../../../redux/reducers/loader";
import TextEditor from '../../../Components/TextEditor';
import { Button, Divider, Typography, Card } from 'antd';

const TermsConditions = () => {
  const dispatch = useDispatch();
  const permissions = useSelector((state) => state?.role?.permissions);
  const [editorLoaded, setEditorLoaded] = useState(false);
  const [errors, setErrors] = useState({});
  const [hasEditPermission, setHasEditPermission] = useState(false);

   const [cmsData, setCmsData] = useState({
        "id": 0,
        "type": "terms-conditions",
        "role": "admin",
        "title_en": "title Englis edit",
        "description_en": "",
        "title_ar": "title Arabic edit",
        "description_ar": ""
    });

  const validateForm = (data) => {
    const errorsData = {};
    if (!data?.description_en || !CUSTOM.removeHtmlFromString(data?.description_en).trim()) {
      errorsData.description_en = "Description (English) is required";
    }
    if (!data?.description_ar || !CUSTOM.removeHtmlFromString(data?.description_ar).trim()) {
      errorsData.description_ar = "Description (Arabic) is required";
    }
    return errorsData;
  };

  const getCms = async () => {
    dispatch(changeLoader(true));
    setErrors({...errors, description_en: "", description_ar: ""});
    try {
      const inputData = { type: 'terms-conditions' };
      const responseApi = await globalRequest(Apis?.MANAGE_CMS?.GET_CMS, "get", {}, { params: inputData }, true);
      const responseData = responseApi?.data;
     if (responseData?.status === "SUCCESS") {
      const cmsLocales = responseData?.data?.cmsLocales || [];
      setCmsData({
        id: responseData?.data?.id,
        type: responseData?.data?.type || "",
        role: responseData?.data?.userRole || "",
        title_en: CUSTOM?.getdataByKey(cmsLocales, "en", "title") || "",
        description_en: CUSTOM?.getdataByKey(cmsLocales, "en", "description") || "",
        title_ar: CUSTOM?.getdataByKey(cmsLocales, "ar", "title") || "",
        description_ar: CUSTOM?.getdataByKey(cmsLocales, "ar", "description") || "",
      });
    }
      setEditorLoaded(false);
      setEditorLoaded(true);
    } catch (e) {
      toast.error(e?.message || "Something went wrong");
    }
    dispatch(changeLoader(false));
  };

  const addCms = async (e) => {

  const errorValidation = validateForm(cmsData);
  if (Object.keys(errorValidation).length === 0) {
    dispatch(changeLoader(true));
    try {
      const inputData = { type: 'terms-conditions' };
      const responseApi = await globalRequest(Apis?.MANAGE_CMS?.ADD_CMS, "post", cmsData, {}, { params: inputData }, true);
      const responseData = responseApi?.data;

      if (responseData?.success) {
        toast.success(responseData?.message || "Data added successfully");
        getCms();
      } else {
        toast.error(responseData?.message || "Save failed");
      }
    } catch (e) {
      toast.error(e?.message || "Something went wrong");
    }
    dispatch(changeLoader(false));
  } else {
    setErrors(errorValidation);
  }
};


const handleEditorValueChange = (value, editorId = "en-editor") => {
  if (editorId === 'en-editor') {
    setCmsData({ ...cmsData, description_en: value });
    setErrors({ ...errors, description_en: "" });
  } else {
    setCmsData({ ...cmsData, description_ar: value });
    setErrors({ ...errors, description_ar: "" });
  }
};

  useEffect(() => {
  getCms();
}, []);

console.log(
  'Edit Permission:',
  CUSTOM.isEditPermissionm(permissions, 'Manage CMS', 'edit')
);
  return (
    <>
      {editorLoaded && (
     
          <Card className="p-6 space-y-4">
            { !CUSTOM.isEditPermissionm(permissions, 'Manage CMS', 'edit') ?
              <div style={{ backgroundColor: '#f44336', color: 'white', padding: '12px 16px', borderRadius: '4px' }}>
                You are not authorized to edit!
              </div>: null
            }

            <Typography className="text-xl font-semibold" align="left">
              Terms & Conditions
            </Typography>
            <Divider />

            {/* English Description */}
            <span className={`${CUSTOM.isEditPermissionm(permissions, 'Manage CMS', 'edit') ? "" : "disable-permission"}`}>
              <div className="editor-height mb-3">
                <Typography className="text-sm sm:text-lg font-semibold mb-2" align="left">
                  Description in English
                </Typography>
                <TextEditor
                  placeholder="Description in English"
                  name="description"
                  editorLoaded={editorLoaded}
                  value={cmsData.description_en}
                  onChange={(val) => handleEditorValueChange(val, "en-editor")}
                  disabled={!hasEditPermission}
                />
                {errors?.description_en && <span className="red-error">{errors?.description_en}</span>}
              </div>

              {/* Arabic Description */}
              <div className="editor-height mb-3">
                <Typography className="text-sm sm:text-lg font-semibold mb-2" align="left">
                  Description in Arabic
                </Typography>
                <TextEditor
                  name="description"
                  placeholder="Description in Arabic"
                  editorLoaded={editorLoaded}
                  value={cmsData.description_ar}
                  onChange={(val) => handleEditorValueChange(val, "ar-editor")}
                  disabled={!hasEditPermission}
                />
                {errors?.description_ar && <span className="red-error">{errors?.description_ar}</span>}
              </div>
            </span>
            <Divider />
            <div className="flex justify-end gap-3">
              <Button type="button" onClick={getCms}>
                Cancel
              </Button>
              <Button disabled={!CUSTOM.isEditPermissionm(permissions, 'Manage CMS', 'edit')}
              variant="contained"
              onClick={addCms}
              >
                SAVE
              </Button>
            </div>
          </Card>
       )}
    </>
  );
};
export default TermsConditions;
